module.exports = __webpack_public_path__ + "img/fancyformatting.0858d066.png";